import styled from 'react-emotion';

export const HeaderPlaceHolder = styled.div`
  padding: 0px;
  @media (max-width: 767px) {
    padding: 70px 0px 0px;
  }
`;

export const HeaderWrapper = styled.div`
  padding: 27px 0 0 44px;
  img {
    max-width: 114px;
  }

  @media (max-width: 767px) {
    padding: 33px 0 0 10px;
    top: 0px;
    position: fixed;
    z-index: 2;
    width: 100%;
    background-color: #ffffff;
    a {
      pointer-events: none;
      cursor: default;
    }
  }
`;
